import { render, staticRenderFns } from "./SsoUserPicker.vue?vue&type=template&id=3364be70"
import script from "./SsoUserPicker.vue?vue&type=script&lang=ts"
export * from "./SsoUserPicker.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports